import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Chip,
  Typography,
  Button,
} from "@mui/material";
import {  Visibility , Edit} from "@mui/icons-material";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";
// import ConfirmDialog from "../components/ConfirmDialog";
import FallbackImage from "../components/FallbackImage";
import { getImageFullUrl, pageRoute } from "../utils/common";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const ProductListPage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchParams] = useSearchParams();
  const vendorId = searchParams.get("id");

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [approvalStatusFilter, setApprovalStatusFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // ✅ Confirm dialog state
  // const [confirmOpen, setConfirmOpen] = useState(false);
  // const [deleteData, setDeleteData] = useState({});

  // ✅ Show confirm dialog before delete
  // const requestDelete = (data) => {
  //   setDeleteData(data);
  //   setConfirmOpen(true);
  // };

  const navigate = useNavigate()

  const pageChange = (url) => {
    navigate(url)
  }

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await apiClient.get("/api/categories");
      setCategories(res?.data?.data || []);
    } catch (err) {
      toast.error("Failed to load categories");
    }
  };

  // Fetch products
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get("/api/products", {
        params: {
          search,
          status: statusFilter,
          approvalStatus: approvalStatusFilter,
          categoryId: categoryFilter,
          page: page + 1, // backend usually 1-based
          limit: rowsPerPage,
          vendorId: vendorId
        },
      });

      setProducts(res?.data?.data?.products || []);
      setTotalCount(res?.data?.data?.total || 0);
    } catch (err) {
      toast.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Refetch when filters/search/page/rowsPerPage change
  useEffect(() => {
    fetchProducts();
  }, [search, statusFilter, categoryFilter, page, rowsPerPage, vendorId, approvalStatusFilter]);

  // Toggle status
  // const handleStatusChange = async (id, newStatus) => {
  //   try {
  //     await apiClient.put(`/api/products/${id}`, { status: newStatus });
  //     toast.success("Status updated");
  //     fetchProducts();
  //   } catch {
  //     toast.error("Failed to update status");
  //   }
  // };

  // Delete product
  // const handleDelete = async (id) => {
  //   try {
  //     await apiClient.delete(`/api/products/${id}`);
  //     toast.success("Product deleted");
  //     fetchProducts();
  //   } catch {
  //     toast.error("Failed to delete product");
  //   }
  // };

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" gutterBottom>
          Product List
        </Typography>
        {/* <Button variant="outlined" onClick={() => {
          pageChange(pageRoute.productAdd)
        }}>
          Add Product
        </Button> */}
      </Box>
      {/* Search & Filters */}
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
        <TextField
          label="Search"
          size="small"
          value={search}
          onChange={(e) => {
            setPage(0); // reset page
            setSearch(e.target.value);
          }}
        />
        <TextField
          select
          size="small"
          label="Filter by Status"
          value={statusFilter}
          onChange={(e) => {
            setPage(0);
            setStatusFilter(e.target.value);
          }}
          sx={{ width: 200 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="inactive">Inactive</MenuItem>
        </TextField>
        <TextField
          select
          size="small"
          label="Filter by Approval"
          value={approvalStatusFilter}
          onChange={(e) => {
            setPage(0);
            setApprovalStatusFilter(e.target.value);
          }}
          sx={{ width: 200 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="approved">Approved</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
        </TextField>
        <TextField
          select
          size="small"
          label="Filter by Category"
          value={categoryFilter}
          onChange={(e) => {
            setPage(0);
            setCategoryFilter(e.target.value);
          }}
          sx={{ width: 250 }}
        >
          <MenuItem value="">All</MenuItem>
          {categories.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.name}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      {/* Table */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Product Name</TableCell>
              {/* <TableCell>Product Code</TableCell> */}
              {/* <TableCell>Price</TableCell>
              <TableCell>Stock Left</TableCell>
              <TableCell>Sell Stock</TableCell> */}
              <TableCell>Status</TableCell>
              <TableCell align="center">
                Approval Status
              </TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {products.length > 0 ? (
              products.map((row) => (
                <TableRow key={row.id}>
                  <TableCell><FallbackImage
                    src={getImageFullUrl(row.thumbnail)}
                    style={{ maxHeight: '50px' }}
                  /></TableCell>
                  <TableCell>{row.name}</TableCell>
                  {/* <TableCell>{row.productCode}</TableCell> */}
                  {/* <TableCell>₹{row.price}</TableCell>
                  <TableCell>{row.stock}</TableCell>
                  <TableCell>{row.stockSell}</TableCell> */}
                  <TableCell>
                    {/* <Switch
                      checked={row.status === "active"}
                      onChange={(e) =>
                        handleStatusChange(
                          row.id,
                          e.target.checked ? "active" : "inactive"
                        )
                      }
                    /> */}
                     <Chip
                      size="small"
                      variant="outlined"
                      label={
                        row?.status === "active"
                          ? "Active"
                          : row?.status === "inactive"
                          ? "Inactive"
                          : "Inactive"
                      }
                      color={
                        row?.status === "active"
                          ? "success"
                          : row?.status === "inactive"
                          ? "warning"
                          : "default"
                      }
                      sx={{ fontWeight: 700, fontSize: 10 }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      size="small"
                      // variant="outlined"
                      label={
                        row?.approvalStatus === "approved"
                          ? "Approved"
                          : row?.approvalStatus === "rejected"
                          ? "Rejected"
                          : row?.approvalStatus === "pending"
                          ? "Pending"
                          : "Pending"
                      }
                      color={
                        row?.approvalStatus === "approved"
                          ? "success"
                          : row?.approvalStatus === "rejected"
                          ? "error"
                          : row?.approvalStatus === "pending"
                          ? "warning"
                          : "default"
                      }
                      sx={{ fontWeight: 700, fontSize: 10 }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() => pageChange(pageRoute.productView + row.id)}
                    >
                      <Visibility />
                    </IconButton>
                   <IconButton
                      color="secondary"
                      onClick={() => pageChange(pageRoute.productEdit + row.id)}
                    >
                      <Edit />
                    </IconButton>
                   {/*   <IconButton
                      color="error"
                      // onClick={() => handleDelete(row.id)}
                      onClick={() => requestDelete(row)}
                    >
                      <Delete />
                    </IconButton> */}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  {loading ? "Loading..." : "No products found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[5, 10, 20]}
      />
      {/* <ConfirmDialog
        open={confirmOpen}
        title={`Delete Product - ${deleteData?.name}`}
        content="Are you sure you want to delete this product?"
        onClose={() => setConfirmOpen(false)}
        onConfirm={() => {
          handleDelete(deleteData?.id)
          setConfirmOpen(false)
        }}
      /> */}
    </Paper>
  );
};

export default ProductListPage;
